var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_send") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0.371206247 L14,15.699371 C13.9843749,15.8191025 13.9218755,15.9049956 13.8125,15.9570528 C13.7135412,16.0143157 13.6145838,16.0143157 13.515625,15.9570528 L8.4296875,13.4270857 L6.59375,15.8633503 C6.53124969,15.9518476 6.44531305,15.9960955 6.3359375,15.9960955 C6.28385391,15.9960955 6.2447918,15.9908899 6.21875,15.9804784 C6.07291594,15.933627 6,15.8269113 6,15.6603283 L6,12.3338901 C6,12.2453929 6.02343727,12.1777195 6.0703125,12.130868 L13.3515625,2.7606196 L3.890625,10.9283528 C3.82291633,10.9752043 3.74739625,10.9986297 3.6640625,10.9986297 C3.60677055,10.9986297 3.55729187,10.9856156 3.515625,10.959587 L0.1875,9.29636788 C0.062499375,9.23910497 0,9.14540342 0,9.01526043 C0,8.88511744 0.0546869531,8.78100461 0.1640625,8.70291882 L15.5,0.0432475513 C15.6250006,-0.019221084 15.742187,-0.0140154425 15.8515625,0.058864632 C15.9661464,0.142156146 16.0156251,0.246268976 16,0.371206247 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.-Icons/General/send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_send",
    fill: "#8A8888",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "1.-Colors/Blue",
    mask: "url(#mask-2)",
    fill: "#255EBA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -4.000000)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSend);
export default __webpack_public_path__ + "static/media/ic_send.7b57743a05d294f713e0b459268b09f8.svg";
export { ForwardRef as ReactComponent };